import api from "./api";

export interface ApiKeySummary {
  id: string;
  token: string;
  createdAt: string;
  updatedAt: string;
  usage: number;
  rateLimit: number;
}

export interface GetApiKeyResponse {
  hasKey: boolean;
  key?: ApiKeySummary;
}

export interface IssueApiKeyResponse {
  token: string;
  key: ApiKeySummary;
}

export interface SessionPinningConfigResponse {
  enabled: boolean;
}

export const fetchUserApiKey = async (): Promise<GetApiKeyResponse> => {
  const response = await api.get<GetApiKeyResponse>("/user/api-key");
  return response.data;
};

export const issueUserApiKey = async (): Promise<IssueApiKeyResponse> => {
  const response = await api.post<IssueApiKeyResponse>("/user/api-key");
  return response.data;
};

export const fetchSessionPinningConfig = async (): Promise<SessionPinningConfigResponse> => {
  const response = await api.get<SessionPinningConfigResponse>("/user/session-pinning");
  return response.data;
};

export const updateSessionPinningConfig = async (
  enabled: boolean
): Promise<SessionPinningConfigResponse> => {
  const response = await api.put<SessionPinningConfigResponse>("/user/session-pinning", {
    enabled,
  });
  return response.data;
};

export interface ProviderApiKey {
  id: string;
  provider: string;
  keyMask: string;
  createdAt: string;
}

export interface GetProviderApiKeysResponse {
  keys: ProviderApiKey[];
}

export interface AddProviderApiKeyResponse {
  message: string;
  key: ProviderApiKey;
}

export const fetchProviderApiKeys = async (): Promise<GetProviderApiKeysResponse> => {
  const response = await api.get<GetProviderApiKeysResponse>("/provider-keys");
  return response.data;
};

export const addProviderApiKey = async (provider: string, key: string): Promise<AddProviderApiKeyResponse> => {
  const response = await api.post<AddProviderApiKeyResponse>("/provider-keys", { provider, key });
  return response.data;
};

export const deleteProviderApiKey = async (id: string): Promise<void> => {
  await api.delete(`/provider-keys/${id}`);
};
